import Axios from "../utils/axiosInstance";

export const getDispenserSrNodDropDownList = (status,headers) => {
  return Axios.get(`/dispatch/getDispenserSrNodDropDownListForFieldWorkOrder?status=${status}`, {
    headers
  });
};